export const SET_AIR_SEARCH_REQUEST = 'SET_AIR_SEARCH_REQUEST'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const TOGGLE_LOADING_OVERLAY = 'TOGGLE_LOADING_OVERLAY'

export const SET_CALENDAR_PRICING_MAP = 'SET_CALENDAR_PRICING_MAP'
export const SET_CACHE_RESULTS = 'SET_CACHE_RESULTS'
export const UPDATE_BRAND_REFERENCE = 'UPDATE_BRAND_REFERENCE'
export const SET_PCLN_BOOTSTRAP_DATA = 'SET_PCLN_BOOTSTRAP_DATA'

// Meta Information
export const SET_LISTINGS_META_DATA = 'SET_LISTINGS_META_DATA'

// Filters Actions
export const SET_INITIAL_FILTER_INFO = 'SET_INITIAL_FILTER_INFO'
export const SET_CURRENT_FILTER_INFO = 'SET_CURRENT_FILTER_INFO'
export const UPDATE_STOPS_FILTERS_UI = 'UPDATE_STOPS_FILTERS_UI'
export const UPDATE_STOPS_FILTERS_REQ = 'UPDATE_STOPS_FILTERS_REQ'
export const UPDATE_AIRLINE_FILTERS_UI = 'UPDATE_AIRLINE_FILTERS_UI'
export const UPDATE_AIRLINE_FILTERS_REQ = 'UPDATE_AIRLINE_FILTERS_REQ'
export const UPDATE_ATTRIBUTES_FILTERS_REQ = 'UPDATE_ATTRIBUTES_FILTERS_REQ'
export const UPDATE_TIME_FILTERS = 'UPDATE_TIME_FILTERS'
export const RESET_TIME_FILTERS = 'RESET_TIME_FILTERS'
export const UPDATE_ATTRIBUTES_FILTERS_UI = 'UPDATE_ATTRIBUTES_FILTERS_UI'
// export const UPDATE_AIRPORT_FILTERS = 'UPDATE_AIRPORT_FILTERS';
// export const UPDATE_EXACT_DATE_FILTERS = 'UPDATE_EXACT_DATE_FILTERS';
export const TOGGLE_MOBILE_FILTERS_OVERLAY = 'TOGGLE_MOBILE_FILTERS_OVERLAY'
export const UPDATE_AIRPORTS_FILTERS_REQ = 'UPDATE_AIRPORTS_FILTERS_REQ'
export const UPDATE_AIRPORTS_FILTERS_UI = 'UPDATE_AIRPORTS_FILTERS_UI'
export const UPDATE_EXACT_DATE_FILTERS_REQ = 'UPDATE_EXACT_DATE_FILTERS_REQ'
export const UPDATE_EXACT_DATE_FILTERS_UI = 'UPDATE_EXACT_DATE_FILTERS_UI'
export const UPDATE_INCLUDED_CARRIERS = 'UPDATE_INCLUDED_CARRIERS'

// airSearch API calls
export const LISTINGS_IS_LOADING = 'LISTINGS_IS_LOADING'
export const LISTINGS_HAS_ERRORED = 'LISTINGS_HAS_ERRORED'
export const LISTINGS_LOADING_MESSAGE = 'LISTINGS_LOADING_MESSAGE'
export const LISTINGS_FETCH_DATA_SUCCESS = 'LISTINGS_FETCH_DATA_SUCCESS'
export const LISTINGS_LOAD_MORE_SUCCESS = 'LISTINGS_LOAD_MORE_SUCCESS'
export const DISPLAY_INFINITE_SCROLL_LOAD_MORE =
  'DISPLAY_INFINITE_SCROLL_LOAD_MORE'
export const FETCHED_INITIAL_LISTINGS = 'FETCHED_INITIAL_LISTINGS'
export const SET_EXPIRED_SESSION_TIMESTAMP = 'SET_EXPIRED_SESSION_TIMESTAMP'
export const SET_OVERFILTERED_TIMESTAMP = 'SET_OVERFILTERED_TIMESTAMP'
export const SET_OVERFILTERED_BANNER_TEXT = 'SET_OVERFILTERED_BANNER_TEXT'

// Ads
export const PUSH_AD = 'PUSH_AD'
export const UPDATE_ADS_LAST_REFRESH_TIME = 'UPDATE_LAST_REFRESH_TIME'

// Airlines
export const SET_DISPLAY_CARRIERS = 'SET_DISPLAY_CARRIERS'

// Flags
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED'
export const SET_HAS_EXPRESS_DEAL = 'SET_HAS_EXPRESS_DEAL'

// Flex Dates
export const SET_FLEX_DATES_RETAIL = 'SET_FLEX_DATES_RETAIL'
export const SET_FLEX_DATES_EXD = 'SET_FLEX_DATES_EXD'
export const SET_CURRENTLY_VIEWING = 'SET_CURRENTLY_VIEWING'

// SBS Tabs
export const UPDATE_ACTIVE_TAB_ID = 'UPDATE_ACTIVE_TAB_ID'

// Price Breakers
export const SET_PRICE_BREAKERS_DATA = 'SET_PRICE_BREAKERS_DATA'
